import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import Select from "react-select";
import { addIntegrationSchema } from "../../../validations";
import {
	useAddPartnership,
	useGetAllPartner,
	useGetPartnerships,
	useSyncMenuItems,
} from "../../../queryHooks";
import { useStore } from "../../../zustand/store";
import CS from "../../../services/commonService";
import { URL } from "../../../constants/URL";
import Breadcrumbs from "../../common/breadcrumbs";

const AddRestaurant = ({ editFlag }) => {
	const { slug } = useParams();
	const setLoading = useStore((state) => state.setLoading);
	const navigate = useNavigate();
	const { data: getAllPartnerMst } = useGetAllPartner();
	const { data: getPartnershipsDetails, refetch } = useGetPartnerships(slug);
	const [partnershipList, setPartnershipList] = useState(
		getAllPartnerMst?.data
	);

	const [forms, setForms] = useState([
		{
			id: 1,
			partnership: "",
			status: false,
			Lunchbox_API_Key: "",
			Lunchbox_URL_Endpoint: "",
			store_number: "",
			menu_id: "",
			label: "",
			partnership_Error: "",
			Lunchbox_API_Key_Error: "",
			Lunchbox_URL_Endpoint_Error: "",
			store_number_Error: "",
			menu_id_Error: "",
		},
	]);

	const handleDropdownChange = (index, value, label) => {
		console.log("Dropdown change:", { index, value, label });

		setForms((prevForms) =>
			prevForms.map((form, i) => {
				if (i === index) {
					const updatedForm = {
						...form,
						partnership: value.toString(),
						label: label,
						partnership_Error:
							value.toString().trim() === "" ? "*Partnership is required" : "",
					};

					// Check if switching away from Lunchbox - clear Lunchbox fields
					const newPartner = getAllPartnerMst?.data?.find(
						(partner) => partner.id.toString() === value.toString()
					);

					console.log("Selected partner:", newPartner);

					if (newPartner?.code !== "lunchBox") {
						updatedForm.Lunchbox_API_Key = "";
						updatedForm.Lunchbox_URL_Endpoint = "";
						updatedForm.store_number = "";
						updatedForm.menu_id = "";
						updatedForm.Lunchbox_API_Key_Error = "";
						updatedForm.Lunchbox_URL_Endpoint_Error = "";
						updatedForm.store_number_Error = "";
						updatedForm.menu_id_Error = "";
					}

					console.log("Updated form:", updatedForm);
					return updatedForm;
				}
				return form;
			})
		);
	};

	const handleInputChange = (index, field, value) => {
		let error_msg = "";

		// Only validate Lunchbox fields if Lunchbox is selected
		const isLunchbox = isLunchboxPartnership(index);

		if (!value || value === "") {
			if (field === "partnership") {
				error_msg = "*Partnership is required";
			} else if (isLunchbox) {
				error_msg =
					field === "Lunchbox_API_Key"
						? "*Lunchbox api key is required"
						: field === "Lunchbox_URL_Endpoint"
						? "*Lunchbox url endpoint is required"
						: field === "store_number"
						? "*Store number is required"
						: field === "menu_id"
						? "*Menu ID is required"
						: "";
			}
		}

		setForms((prevForms) =>
			prevForms.map((form, i) =>
				i === index
					? { ...form, [field]: value, [`${field}_Error`]: error_msg }
					: form
			)
		);
	};

	const addForm = () => {
		const newForm = {
			id: forms.length,
			partnership: "",
			status: false,
			Lunchbox_API_Key: "",
			Lunchbox_URL_Endpoint: "",
			store_number: "",
			menu_id: "",
			label: "",
			partnership_Error: "",
			Lunchbox_API_Key_Error: "",
			Lunchbox_URL_Endpoint_Error: "",
			store_number_Error: "",
			menu_id_Error: "",
		};
		setForms((prevForms) => [...prevForms, newForm]);
	};

	const removeForm = (index) => {
		setForms((prevForms) => prevForms.filter((_, i) => i !== index));
	};

	const getFilteredOptions = (index) => {
		const selectedDropdownValues = forms.map((form, i) => ({
			id: form.id,
			value: form.partnership,
		}));
		let allValue = getAllPartnerMst?.data || [];
		allValue = allValue.filter((partner) =>
			selectedDropdownValues.every((selected) => {
				if (selected.id === index) {
					return true;
				}
				return selected.value !== partner.id;
			})
		);
		return allValue.map((option) => ({
			value: option.id,
			label: option.label,
		}));
	};

	const isLunchboxPartnership = (index) => {
		const selectedPartnerId = forms[index].partnership;
		if (!selectedPartnerId || !getAllPartnerMst?.data) {
			return false;
		}

		const selectedPartner = getAllPartnerMst.data.find(
			(partner) => partner.id.toString() === selectedPartnerId.toString()
		);

		const isLunchbox = selectedPartner?.code === "lunchBox";
		console.log("Partnership check:", {
			index,
			selectedPartnerId,
			selectedPartner,
			isLunchbox,
			allPartners: getAllPartnerMst.data,
		});

		return isLunchbox;
	};

	const validateForms = () => {
		let isValid = true;
		const updatedForms = forms.map((form, index) => {
			let newForm = { ...form };

			if (!form.partnership.toString().trim()) {
				newForm.partnership_Error = "*Partnership is required";
				isValid = false;
			} else {
				newForm.partnership_Error = "";
			}

			// Only validate Lunchbox fields if Lunchbox is selected
			if (isLunchboxPartnership(index)) {
				if (!form.Lunchbox_API_Key.trim()) {
					newForm.Lunchbox_API_Key_Error = "*Lunchbox api Key is required";
					isValid = false;
				} else {
					newForm.Lunchbox_API_Key_Error = "";
				}
				if (!form.Lunchbox_URL_Endpoint.trim()) {
					newForm.Lunchbox_URL_Endpoint_Error =
						"*Lunchbox url endpoint is required";
					isValid = false;
				} else {
					newForm.Lunchbox_URL_Endpoint_Error = "";
				}
				if (!form.store_number.trim()) {
					newForm.store_number_Error = "*Store number is required";
					isValid = false;
				} else {
					newForm.store_number_Error = "";
				}
				if (!form.menu_id.trim()) {
					newForm.menu_id_Error = "*Menu ID is required";
					isValid = false;
				} else {
					newForm.menu_id_Error = "";
				}
			} else {
				// Clear errors for non-Lunchbox partnerships
				newForm.Lunchbox_API_Key_Error = "";
				newForm.Lunchbox_URL_Endpoint_Error = "";
				newForm.store_number_Error = "";
				newForm.menu_id_Error = "";
			}

			return newForm;
		});

		setForms(updatedForms);
		return isValid;
	};

	const { values, errors, handleSubmit, touched } = useFormik({
		initialValues: forms,
		validationSchema: addIntegrationSchema,
		onSubmit: (value) => {
			if (validateForms()) {
				const formattedForms = forms.map(({ id, status, ...rest }, index) => {
					const baseData = {
						partner_id: rest.partnership,
						status: status ? 1 : 0,
					};

					// Only include Lunchbox fields if Lunchbox is selected
					if (isLunchboxPartnership(index)) {
						return {
							...baseData,
							partner_api_key: rest.Lunchbox_API_Key,
							partner_api_url: rest.Lunchbox_URL_Endpoint,
							ext_restaurant_id: rest.store_number,
							menu_id: rest.menu_id,
						};
					}

					return baseData;
				});

				addPartnership({
					restaurantId: slug,
					body: {
						partners: formattedForms,
					},
				});
			}
		},
	});

	const {
		mutateAsync: addPartnership,
		error: errorAddPartnership,
		data: dataAddPartnership,
		isLoading: isLoadingAddPartnership,
	} = useAddPartnership();

	const {
		mutateAsync: syncMenuItems,
		error: errorSyncMenuItems,
		data: dataSyncMenuItems,
		isLoading: isLoadingSyncMenuItems,
	} = useSyncMenuItems();

	// Helper function to check if Lunchbox is connected and active
	const isLunchboxConnectedAndActive = (index) => {
		if (!getPartnershipsDetails?.data?.partners) return false;

		const selectedPartnerId = forms[index].partnership;
		if (!selectedPartnerId || !getAllPartnerMst?.data) return false;

		const selectedPartner = getAllPartnerMst.data.find(
			(partner) => partner.id.toString() === selectedPartnerId.toString()
		);

		if (selectedPartner?.code !== "lunchBox") return false;

		// Check if this partnership exists in the connected partnerships and is active
		const connectedPartnership = getPartnershipsDetails.data.partners.find(
			(partnership) =>
				partnership.partner_id.toString() === selectedPartnerId.toString()
		);

		return connectedPartnership && connectedPartnership.status === 1;
	};

	// Handle sync menu button click
	const handleSyncMenu = async () => {
		try {
			await syncMenuItems(slug);
		} catch (error) {
			console.error("Sync menu error:", error);
		}
	};

	useEffect(() => {
		if (getPartnershipsDetails && getAllPartnerMst) {
			if (getPartnershipsDetails.status === "success") {
				setForms(
					getPartnershipsDetails?.data?.partners.map((partner, index) => {
						const selectedPartner = getAllPartnerMst?.data?.find(
							(p) => p.id === partner.partner_id
						);
						return {
							id: index + 1,
							partnership: partner.partner_id.toString(),
							Lunchbox_API_Key: partner.partner_api_key,
							Lunchbox_URL_Endpoint: partner.partner_api_url,
							store_number: partner.ext_restaurant_id || "",
							menu_id: partner.menu_id || "",
							status: partner.status === 0 ? false : true,
							label: selectedPartner?.label || "",
							partnership_Error: "",
							Lunchbox_API_Key_Error: "",
							Lunchbox_URL_Endpoint_Error: "",
							store_number_Error: "",
							menu_id_Error: "",
						};
					})
				);
			} else if (getPartnershipsDetails.status === "fail") {
				CS.showErrorMessage(getPartnershipsDetails.message);
			}
		}
	}, [getPartnershipsDetails, getAllPartnerMst]);

	useEffect(() => {
		if (dataAddPartnership) {
			if (dataAddPartnership.status === "success") {
				navigate(URL.restaurants, { replace: true });
				CS.showSuccessMessage(dataAddPartnership.message);
			} else if (dataAddPartnership.status === "fail") {
				CS.showErrorMessage(dataAddPartnership.message);
			}
		}
	}, [dataAddPartnership]);

	useEffect(() => {
		if (errorAddPartnership) {
			CS.showErrorMessage(errorAddPartnership.response?.data?.message);
		}
	}, [errorAddPartnership]);

	useEffect(() => {
		setLoading(isLoadingAddPartnership);
	}, [isLoadingAddPartnership]);

	useEffect(() => {
		if (dataSyncMenuItems) {
			if (dataSyncMenuItems.status === "success") {
				CS.showSuccessMessage("Menu items synced successfully!");
			} else if (dataSyncMenuItems.status === "fail") {
				CS.showErrorMessage(dataSyncMenuItems.message);
			}
		}
	}, [dataSyncMenuItems]);

	useEffect(() => {
		if (errorSyncMenuItems) {
			CS.showErrorMessage(
				errorSyncMenuItems.response?.data?.message ||
					"Failed to sync menu items"
			);
		}
	}, [errorSyncMenuItems]);

	useEffect(() => {
		setLoading(isLoadingAddPartnership || isLoadingSyncMenuItems);
	}, [isLoadingAddPartnership, isLoadingSyncMenuItems]);

	return (
		<>
			<div className="d-flex align-items-center justify-content-between flex-wrap mb-2">
				<Breadcrumbs
					title="Restaurants Management"
					data={[
						{ label: "Restaurants", path: URL.restaurants },
						{ label: `${editFlag ? "Edit" : "Add"} Integration Details` },
					]}
				/>
				<form onSubmit={handleSubmit} style={{ width: "100%" }}>
					<div className=" card restaurant-card mb-5">
						<div className="modal-header p-0 pb-3  ">
							<h5 className="box-title modal-title">
								<i className="bx bx-user mr-1"></i> Integration Info
							</h5>
						</div>
						{forms.map((form, index) => (
							<div className="col-md-12" key={form.id}>
								{index > 0 ? (
									<hr
										style={{
											height: "1px",
											backgroundColor: "lightGray",
											border: "none",
										}}
									/>
								) : (
									""
								)}
								<div
									key={index}
									style={{
										display: "flex",
										justifyContent: "space-between",
										alignItems: "center",
										marginTop: "30px",
									}}
								>
									<p
										style={{
											margin: 0,
											fontWeight: "bold",
											marginBottom: "10px",
										}}
									>
										Platform {index + 1}
									</p>
									{index > 0 && (
										<button
											type="button"
											style={{
												color: "#FB1111",
												backgroundColor: "white",
												fontWeight: "bold",
											}}
											onClick={() => {
												removeForm(index);
											}}
										>
											<span className="bx bx-trash-alt mr-2"></span>
											Remove
										</button>
									)}
								</div>

								<div className="row align-items-end">
									<div className="col-md-12">
										<div className="user-title-info user-details">
											<div className="row">
												<div
													className="form-group col-md-6 mb-md-4 mb-3 "
													style={{ marginTop: "9px" }}
												>
													<label className="mb-1" htmlFor="phonelId">
														partnership
													</label>
													<Select
														className="default-select"
														placeholder="Select Business Type"
														name={`forms[${index}].partnership`}
														options={getFilteredOptions(index)}
														value={{
															value: forms[index].partnership,
															label: forms[index].label,
														}}
														onChange={(e) =>
															handleDropdownChange(index, e.value, e.label)
														}
													></Select>
													<span className="text-danger d-block">
														{form.partnership_Error != ""
															? form.partnership_Error
															: null}
													</span>
												</div>

												{/* Lunchbox-specific fields */}
												{(() => {
													const selectedPartnerId = forms[index].partnership;
													const selectedPartner = getAllPartnerMst?.data?.find(
														(partner) =>
															partner.id.toString() ===
															selectedPartnerId.toString()
													);
													const isLunchbox =
														selectedPartner?.code === "lunchBox";

													console.log("Render check:", {
														index,
														selectedPartnerId,
														selectedPartner,
														isLunchbox,
													});

													return isLunchbox;
												})() && (
													<>
														<div
															className="form-group col-md-6 mb-md-4 mb-3"
															style={{ marginTop: "9px" }}
														>
															<label className="mb-0" htmlFor="LunchboxApiKey">
																Lunchbox API Key
															</label>
															<div className="w-100">
																<input
																	maxLength="255"
																	type="text"
																	className="form-control"
																	id="LunchboxApiKey"
																	name="LunchboxApiKey"
																	placeholder="Enter Lunchbox Api Key"
																	value={form.Lunchbox_API_Key}
																	onChange={(e) =>
																		handleInputChange(
																			index,
																			"Lunchbox_API_Key",
																			e.target.value
																		)
																	}
																/>
																<span className="text-danger d-block">
																	{form.Lunchbox_API_Key_Error != ""
																		? form.Lunchbox_API_Key_Error
																		: null}
																</span>
															</div>
														</div>
														<div className="form-group col-md-6 mb-md-4 mb-3">
															<label
																style={{ width: "100%" }}
																className="mb-0"
																htmlFor="LunchboxUrl"
															>
																Lunchbox URL Endpoint
															</label>
															<div className="w-100">
																<input
																	maxLength="255"
																	type="text"
																	className="form-control"
																	id="LunchboxUrl"
																	name="LunchboxUrl"
																	placeholder="Enter Lunchbox Url Endpoint"
																	value={form.Lunchbox_URL_Endpoint}
																	onChange={(e) =>
																		handleInputChange(
																			index,
																			"Lunchbox_URL_Endpoint",
																			e.target.value
																		)
																	}
																/>
																<span className="text-danger d-block">
																	{form.Lunchbox_URL_Endpoint_Error != ""
																		? form.Lunchbox_URL_Endpoint_Error
																		: null}
																</span>
															</div>
														</div>
														<div className="form-group col-md-6 mb-md-4 mb-3">
															<label
																style={{ width: "100%" }}
																className="mb-0"
																htmlFor="storeNumber"
															>
																Store Number
															</label>
															<div className="w-100">
																<input
																	maxLength="255"
																	type="text"
																	className="form-control"
																	id="storeNumber"
																	name="storeNumber"
																	placeholder="Enter Store Number"
																	value={form.store_number}
																	onChange={(e) =>
																		handleInputChange(
																			index,
																			"store_number",
																			e.target.value
																		)
																	}
																/>
																<span className="text-danger d-block">
																	{form.store_number_Error != ""
																		? form.store_number_Error
																		: null}
																</span>
															</div>
														</div>
														<div className="form-group col-md-6 mb-md-4 mb-3">
															<label
																style={{ width: "100%" }}
																className="mb-0"
																htmlFor="menuId"
															>
																Menu ID
															</label>
															<div className="w-100">
																<input
																	maxLength="255"
																	type="text"
																	className="form-control"
																	id="menuId"
																	name="menuId"
																	placeholder="Enter Menu ID"
																	value={form.menu_id}
																	onChange={(e) =>
																		handleInputChange(
																			index,
																			"menu_id",
																			e.target.value
																		)
																	}
																/>
																<span className="text-danger d-block">
																	{form.menu_id_Error != ""
																		? form.menu_id_Error
																		: null}
																</span>
															</div>
														</div>

														{/* Sync Menu Button - only show if Lunchbox is connected and active */}
														{isLunchboxConnectedAndActive(index) && (
															<div className="form-group col-md-12 mb-md-4 mb-3">
																<button
																	type="button"
																	className="btn btn-success"
																	onClick={handleSyncMenu}
																	disabled={isLoadingSyncMenuItems}
																	style={{
																		marginTop: "10px",
																		display: "flex",
																		alignItems: "center",
																		gap: "8px",
																	}}
																>
																	<i className="bx bx-sync"></i>
																	{isLoadingSyncMenuItems
																		? "Syncing..."
																		: "Sync Menu"}
																</button>
																<small className="text-muted mt-1 d-block">
																	Sync menu items from Lunchbox integration
																</small>
															</div>
														)}
													</>
												)}

												{/* Status field - always shown */}
												<div className="form-group col-md-6 mb-md-4 mb-3">
													<label
														style={{ width: "100%" }}
														className="mb-0"
														htmlFor="restaurantName"
													>
														Status
													</label>
													<div
														className="d-flex align-items-center"
														style={{ marginTop: "8px" }}
													>
														<span className="sub-content">
															<div
																className={`toggle-container ${
																	forms[index].status ? "toggled" : ""
																}`}
																onClick={() =>
																	handleInputChange(
																		index,
																		"status",
																		!forms[index].status
																	)
																}
															>
																<div className="toggle-button"></div>
															</div>
														</span>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						))}
						<div className="col-md-12 mt-4 btn-blocks text-right">
							<button className="btn btn-primary glow-primary mr-4">
								{editFlag ? "Update" : "Add"}
							</button>
							<Link className="btn btn-outline-primary" to={URL.restaurants}>
								Cancel
							</Link>
						</div>
						{forms.length < getAllPartnerMst?.data?.length && (
							<div className="col-sm-12 d-flex justify-content-center">
								<button
									type="button"
									className=" btn btn-outline-primary"
									onClick={() => addForm()}
									style={{
										fontSize: "1rem",
										marginTop: "20px",
										height: "40px",
										color: "#5A8DEE",
										outline: "none",
										padding: "0px 30px",
									}}
								>
									<span
										style={{
											width: "20px",
											height: "20px",
											marginRight: "10px",
											fontSize: "1.2rem",
										}}
									>
										{" "}
										+{" "}
									</span>{" "}
									Add Another
								</button>
							</div>
						)}
					</div>
				</form>
			</div>
		</>
	);
};

export default AddRestaurant;
